import { Box, Grid, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { ApplicationWordArt, AuthenticationContainer, StyledLoginFormContainer } from "../../components";

export const LoggedOutTemplate = () => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<Grid container direction="column" gap={6}>
					<Box sx={{ margin: "auto" }}>
						<ApplicationWordArt width={300} />
					</Box>

					<Grid container direction="column" alignItems="center" gap={1}>
						<Typography variant="h1" color="white">
							<FormattedMessage id="logged-out.header" defaultMessage="You have been logged out" />
						</Typography>

						<Link to="/login" component={RouterLink} sx={{ color: "white" }}>
							<FormattedMessage id="logged-out.back" defaultMessage="Back to login" />
						</Link>
					</Grid>
				</Grid>
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
